import initializeValues from './initializeValues';
import openModal from './openModal';
import setIsNewRecord from './setIsNewRecord';

export default (projectId) => (dispatch) => {
    dispatch(initializeValues({ project: projectId ? projectId : '' }));
    dispatch(setIsNewRecord(true));
    dispatch(openModal(true));
};
